import { Form, FormBuilder } from '@formio/react'
import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { FormTypes, getMappingOfForms } from '../'
import { Button } from '../../Button'
import { ToastTypes, launchToast } from '../../Toast'
import styles from './Builder.module.css'

export const Builder = () => {
    const { formName } = useParams<{ formName: FormTypes }>()

    const rawTempForm = localStorage.getItem('tempForm')
    const tempFormLocalStorage = React.useMemo(() => {
        return rawTempForm !== null ? JSON.parse(rawTempForm as string) : undefined
    }, [rawTempForm])
    const [tempForm, setTempForm] = React.useState(tempFormLocalStorage)

    const formData = getMappingOfForms[formName]
    const changeForm = (form: any) => {
        setTempForm(form)
        localStorage.setItem('tempForm', JSON.stringify(form))
    }
    const downloadForm = (data: any, name: string, version: number) => {
        const filename = `${name}v${version}.json`
        const jsonStr = JSON.stringify(data, null, 2) // 2 spaces indentation for prettified JSON
        const blob = new Blob([jsonStr], { type: 'text/json' })
        const url = URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.download = filename
        link.click()

        // After triggering the download, revoke the object URL to free up memory
        URL.revokeObjectURL(url)
    }

    return (
        <div>
            <div className={styles.outer}>
                <div className={styles.actions}>
                    <Button
                        onClick={() => {
                            try {
                                downloadForm(tempForm, formName, formData?.currentVersion + 1)
                                setTempForm(undefined)
                                localStorage.removeItem('tempForm')
                            } catch (error) {
                                launchToast(ToastTypes.Error, 'Cant store form!')
                            }
                        }}
                    >
                        Download form JSON
                    </Button>
                </div>
                <div className="bootstrap-scope">
                    <FormBuilder
                        form={tempForm || formData?.currentForm}
                        // bad types
                        // @ts-ignore1
                        onChange={(schema: any) => changeForm(schema)}
                    />
                    <div className={styles.preview}>
                        <Form form={tempForm} />
                    </div>
                </div>
            </div>
        </div>
    )
}
export const BuilderButton = ({ formName }: { formName: FormTypes }) => {
    const history = useHistory()
    const formData = getMappingOfForms[formName]
    const isLocalhost = Boolean(window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
    if (!isLocalhost) {
        return null
    }
    return (
        <Button size="small" view="secondary" onClick={() => history.push('formEdit/' + FormTypes.DeviceBasicConfigV2)}>
            Edit {formData?.name}{' '}
        </Button>
    )
}
